// extracted by mini-css-extract-plugin
export var dividerContainer = "_83-0";
export var line = "_83-1";